module.exports = __webpack_public_path__ + "static2023-4-17/img/guide-home.db32ec61.png";